export default "__VITE_ASSET__CvDXzpAF__"